<form class="row-cols-sm-auto" [ngClass]="{ 'no-margin': noMargin }">
  <div class="col-12 input-wrapper">
    <div class="dp-hidden position-absolute">
      <div
        class="input-group"
        [ngClass]="{
          'no-margin': noMargin,
          'position-center': displayPosition === 'center',
          'position-left': displayPosition === 'left',
          'position-right': displayPosition === 'right'
        }">
        <input
          class="form-control"
          #datepicker="ngbDatepicker"
          [autoClose]="'outside'"
          [minDate]="!pastDates ? minDate : { year: 1900, month: 1, day: 1 }"
          [maxDate]="maxDate || { year: 2099, month: 12, day: 31 }"
          [markDisabled]="isDisabled"
          [displayMonths]="2"
          [dayTemplate]="t"
          [startDate]="fromDate!"
          [disabled]="disabled"
          (dateSelect)="onDateSelection($event)"
          name="datepicker"
          ngbDatepicker
          outsideDays="hidden"
          tabindex="-1" />
        <ng-template #t let-date let-focused="focused">
          <span
            class="custom-day"
            [class.focused]="focused"
            [class.range]="isRange(date)"
            [class.faded]="isHovered(date) || isInside(date)"
            (mouseenter)="hoveredDate = date"
            (mouseleave)="hoveredDate = null">
            {{ date.day }}
          </span>
        </ng-template>
      </div>
    </div>
    <div class="input-group" tabindex="0">
      <img src="assets/images/calendar-icon.svg" alt="calendar" />
      <input
        class="form-control from"
        #dpFromDate
        [value]="formatter.format(fromDate)"
        [disabled]="disabled"
        (input)="fromDate = validateInput(fromDate, dpFromDate.value)"
        (click)="datepicker.toggle()"
        placeholder="dd.mm.gggg"
        name="dpFromDate" />
      <div class="dash" [ngClass]="{ empty: !fromDate }">-</div>
      <input
        class="form-control to"
        #dpToDate
        [value]="formatter.format(toDate)"
        [disabled]="disabled"
        (input)="toDate = validateInput(toDate, dpToDate.value)"
        (click)="datepicker.toggle()"
        placeholder="dd.mm.gggg"
        name="dpToDate" />
    </div>
  </div>
</form>
